var map = {
	"./music-instructions.json": 3565,
	"./music-library-intro2024.json": 3566,
	"./music-library-launch2024.json": 3567,
	"./music-progression.json": 3568,
	"./startSourcesAdvanced.json": 3569,
	"./startSourcesSimple.json": 3570,
	"./startSourcesSimple2.json": 3571,
	"./startSourcesTracks.json": 3572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3424;